import Modal from "~/common/components/Modal";
import useMediaQuery, { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { AlertTitle, Button, Stack } from "@schaeffler-commerce/design-system";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "@schaeffler-commerce/design-system";
import { doLogout } from "~/features/auth/api/doLogout";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { redirectToSrp } from "~/utils/redirectionUtil";
import { Alert } from "@schaeffler-commerce/design-system";

const SignOutFromPlusPopUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const isMinTablet = useIsMinTabletSize();
  const [showPopup, setShowPopup] = useState(true);

  const onClose = () => {
    setShowPopup(false);
    redirectToSrp(navigate);
  };

  const onLogout = () => {
    setShowPopup(false);
    doLogout(true, true);
  };

  const footer = (
    <Stack direction={"row"} sx={{
      gap: 1
    }}>
      <Button color={"primary"} variant={"text"} data-test-id={"login-cancel-button"} onClick={onClose}>
        {t("cancel")}
      </Button>
      <Button fullWidth={!isMinTablet} onClick={onLogout}>
        {t("popup.sign.out")}
      </Button>
    </Stack>
  );

  return (showPopup && (<Modal onClose={onClose} footerChildren={footer} title={t("popup.signout.message")}>
    <Stack direction="column" sx={{
      gap: 3
    }}>
      <div style={{ paddingTop: "8px" }}>
        <Alert severity={"info"}>
          <AlertTitle>{t("popup.signout.info.header")}</AlertTitle>
          {t("popup.signout.info.message")}
        </Alert>
      </div>
    </Stack>
  </Modal>));
};
export default SignOutFromPlusPopUp;
